export default __webpack_public_path__ + "static/media/TPG - Logo2.5a8647a7.png";